// Angular4 - Ionic 3 PWA App
import { NgModule, ErrorHandler } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler, DeepLinkConfig } from 'ionic-angular';
//import { APP_BASE_HREF, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { MyApp } from './app.component';
import { TranslateModule } from '@ngx-translate/core';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { WizardComponent } from './lib/wizard/wizard.component';
import { AlertComponent } from './lib/alert/alert.component'
import { PhoneInputComponent } from './lib/phone-input/phone-input.component'
import { CountryCodeComponent } from './lib/phone-input/country-code/country-code.component'
import { DonutComponent } from './lib/donut/donut.component'
import { StarRatingComponent } from './lib/star-rating/star-rating.component';
import { VideoComponent } from './lib/video/video.component';
import { TriggerFocusDirective } from './lib/trigger-focus/trigger-focus.directive';

// Pages & Components
import { HomeComponent } from './modules/home/home.component';
import { SigninComponent } from './modules/authentication/components/signin/signin.component';
import { TermsConditionsComponent } from './modules/authentication/components/terms-conditions/terms-conditions.component';
import { JobNearMeComponent } from './modules/job-search/components/jobs-near-me/jobs-near-me.component';
import { PasswordResetComponent } from './modules/authentication/components/password-reset/password-reset.component';
import { CandidateProfileComponent } from './modules/candidate-profile/candidate-profile.component';
import { ReviewCandidateProfileComponent } from './modules/review-candidate-profile/review-candidate-profile.component';
import { AuthenticationComponent } from './modules/authentication/authentication.component';
import { JobSearchComponent } from './modules/job-search/job-search.component';
import { JobSearchFilterComponent } from './modules/job-search/components/job-filter/job-filter.component';
import { JobSearchLocationComponent } from './modules/job-search/components/job-location-modal/job-location-modal.component';
import { JobDetailsPage } from './modules/job-search/components/job-details/job-details.component';
import { JobShareComponent } from './modules/job-search/components/job-share/job-share.component';
import { JobListComponent } from './modules/job-search/components/job-list/job-list.component';
import { STSMapComponent } from './modules/job-search/components/google-map/google-map.component';
import { JobDataComponent } from './modules/job-search/components/job-data/job-data.component';
import { JobAssessmentComponent } from './modules/job-search/components/job-assessment/job-assessment.component';
import { TimelineComponent } from './modules/timeline/timeline.component';
import { CustomNavbar } from './lib/custom-navbar/custom-navbar';
import { JobAlertComponent } from './modules/job-alert/job-alert.component';
import { UploadResumePopupComponent } from './modules/authentication/components/upload-resume-popup/upload-resume-popup.component';
import { AddResumeComponent } from './modules/authentication/components/add-resume/add-resume.component';
import { CustomContentComponent } from './modules/home/custom-content/custom-content.component';
import { GetMatchedComponent } from './modules/home/get-matched/get-matched.component';
import { SearchJobComponent } from './modules/home/search-job/search-job.component';
import { JobInfoComponent } from './modules/home/job-info/job-info.component';
import { EditProfileComponent } from './modules/edit-profile/edit-profile.component';
import { FileUploadDialogComponent } from './modules/edit-profile/profile/file-upload/file-upload-dialog.component';
import { ViewOfferDialogComponent } from './modules/timeline/view-offer/view-offer-dialog.component';
import { GDPRAlertDialogComponent } from './modules/edit-profile/profile/gdpr-alert/gdpr-alert-dialog.component';
import { ResumeEditComponent } from './modules/edit-profile/resume/resume.component';
import { ProfileEditComponent } from './modules/edit-profile/profile/profile.component';
import { AlertsEditComponent } from './modules/edit-profile/alerts/alerts.component';
import { AttachmentsPageComponent } from './modules/edit-profile/resume/attachments/attachments.component';
import { ReadViewPageComponent } from './modules/edit-profile/resume/read-view/read-view.component';
import { ResTimelinePageComponent } from './modules/edit-profile/resume/res-timeline/res-timeline.component';
import { EditViewPageComponent } from './modules/edit-profile/resume/edit-view/edit-view.component'
import { ReadProfilePageComponent } from './modules/edit-profile/resume/read-profile/read-profile.component';
import { LibrarySelectPageComponent } from './modules/edit-profile/resume/library-select/library-select.component';
import { PrivacyPolicyComponent } from './modules/privacy-policy/privacy-policy.component';
import { JobLinkedInComponent } from './modules/job-search/components/job-linkedin/job-linkedin.component';
import { DocumentUploadComponent } from './modules/candidate-profile/document-upload/document-upload.component';
import { DocumentImportComponent } from './modules/candidate-profile/document-import/document-import.component';
import { SubmitAlertDialogComponent } from '../app/modules/candidate-profile/submit-alert-dialog/submit-alert-dialog.component';

// Providers
import { JobSearchService } from '../../../UI/src/app/shared/job-search/job-search.service';
import { CountryPhoneCodeDetails } from '../../../UI/src/app/shared/phone-numbers/phone-number.service';
import { JobService } from '../../../UI/src/app/shared/job/job.service';
import { ProfileService } from '../../../UI/src/app/shared/profile/profile.service';
import { TimelineService } from '../../../UI/src/app/shared/timeline/timeline.service';
import { AuthenticationService } from '../../../UI/src/app/shared/authentication/authentication.service';
import { ValidationService } from '../../../UI/src/app/shared/validation/validation.service';
import { HTTP_OVERRIDE_PROVIDER } from '../../../UI/src/app/core/http/sumt.interceptor';
import { DiffBetweenDates } from '../../../UI/src/app/shared/pipes/dates-diff.pipe';
import { DistanceConverter } from '../../../UI/src/app/shared/pipes/distance-converter.pipe';
import { PhoneNumberPipe } from '../../../UI/src/app/shared/pipes/phone-number.pipe';
import { SumtDatePipe } from '../../../UI/src/app/shared/pipes/sumt-date.pipe';
import { HtmlToPlainText } from '../../../UI/src/app/shared/pipes/htmlToPlaintext.pipe';
import { GeoLocationService } from '../../../UI/src/app/shared/location/geo-location.service';
import { UploadResumeService } from '../../../UI/src/app/shared/upload-resume/upload-resume.service';
import { SettingsService } from '../../../UI/src/app/shared/settings/settings.service';
import { JobAlertService } from '../../../UI/src/app/shared/job-alert/job-alert.service';
import { SitemapService } from '../../../UI/src/app/shared/sitemap/sitemap.service';
import { ToastControllerService } from '../providers/toast-controller.service';
import { TranslationLoaderService } from '../../../UI/src/app/shared/translation/translation-loader.service';
import { ResumeService } from '../../../UI/src/app/shared/resume/resume.service';
import { ScriptLoadService } from '../../../UI/src/app/core/script-load/script-load.service';
import { Toast508Service } from '../providers/toast-508.service';
import { BrandingService } from '../../../UI/src/app/shared/branding/branding.service';
import { RecaptchaModule, RECAPTCHA_LANGUAGE } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { Storage } from '../../../UI/src/app/shared/constants'
import { DocumentService } from '../../../UI/src/app/shared/document-upload/document-upload.service';
import { multiselectComponent } from './lib/MultiSelect-Textbox/multiselect.component';
import{AutoCompleteComponent } from './lib/autocomplete/autocomplete.component'
import { FilterPipe } from './lib/autocomplete/filter.pipe';
export const deepLinks: DeepLinkConfig = {
  links: [
    { component: HomeComponent, name: 'Home Page', segment: 'home' },
    { component: JobSearchComponent, name: 'Jobs Search', segment: 'search' },
    { component: JobDetailsPage, name: 'Jobs details', segment: 'job/:jobId' },
    { component: AuthenticationComponent, name: 'Authentication', segment: 'auth/request' },
    { component: AddResumeComponent, name: 'Add Resume', segment: 'addResume' },
    { component: ReviewCandidateProfileComponent, name: 'Review Candidate Profile', segment: 'reviewCandidateProfile' },
    { component: CandidateProfileComponent, name: 'Candidate Profile', segment: 'candidate' },
    { component: EditProfileComponent, name: 'Edit Profile', segment: 'editProfile' },
    { component: SigninComponent, name: 'Sign-In', segment: 'signin' },
    { component: DocumentUploadComponent, name: 'Document Upload', segment: 'documents/:Id' },
    { component: TimelineComponent, name: 'Timeline', segment: 'timeline' }
  ]
};

const ionicConfig: any = {
  backButtonText: ''
};

@NgModule({
  declarations: [
    MyApp,
    WizardComponent,
    AlertComponent,
    PhoneInputComponent,
    CountryCodeComponent,
    DonutComponent,
    HomeComponent,
    SigninComponent,
    TermsConditionsComponent,
    JobNearMeComponent,
    CandidateProfileComponent,
    ReviewCandidateProfileComponent,
    AuthenticationComponent,
    JobSearchComponent,
    JobListComponent,
    PasswordResetComponent,
    JobSearchFilterComponent,
    JobSearchLocationComponent,
    STSMapComponent,
    JobDetailsPage,
    JobShareComponent,
    JobDataComponent,
    JobAssessmentComponent,
    TimelineComponent,
    CustomNavbar,
    JobAlertComponent,
    UploadResumePopupComponent,
    DiffBetweenDates,
    DistanceConverter,
    PhoneNumberPipe,
    SumtDatePipe,
    HtmlToPlainText,
    AddResumeComponent,
    CustomContentComponent,
    EditProfileComponent,
    FileUploadDialogComponent,
    ViewOfferDialogComponent,
    GDPRAlertDialogComponent,
    ProfileEditComponent,
    AlertsEditComponent,
    ResumeEditComponent,
    StarRatingComponent,
    ResTimelinePageComponent,
    ReadViewPageComponent,
    EditViewPageComponent,
    AttachmentsPageComponent,
    ReadProfilePageComponent,
    GetMatchedComponent,
    SearchJobComponent,
    LibrarySelectPageComponent,
    JobInfoComponent,
    VideoComponent,
    TriggerFocusDirective,
    PrivacyPolicyComponent,
    JobLinkedInComponent,
    DocumentUploadComponent,
    DocumentImportComponent,
    SubmitAlertDialogComponent,
    multiselectComponent,
    AutoCompleteComponent,
    FilterPipe
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp, ionicConfig, deepLinks),
    TranslateModule.forRoot(),
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    WizardComponent,
    AlertComponent,
    CountryCodeComponent,
    HomeComponent,
    SigninComponent,
    TermsConditionsComponent,
    JobNearMeComponent,
    CandidateProfileComponent,
    ReviewCandidateProfileComponent,
    EditProfileComponent,
    ReadViewPageComponent,
    FileUploadDialogComponent,
    ViewOfferDialogComponent,
    GDPRAlertDialogComponent,
    EditViewPageComponent,
    ResumeEditComponent,
    ProfileEditComponent,
    AlertsEditComponent,
    AuthenticationComponent,
    JobSearchComponent,
    PasswordResetComponent,
    JobAssessmentComponent,
    JobSearchFilterComponent,
    JobSearchLocationComponent,
    JobDetailsPage,
    TimelineComponent,
    CustomNavbar,
    JobAlertComponent,
    UploadResumePopupComponent,
    LibrarySelectPageComponent,
    AddResumeComponent,
    VideoComponent,
    PrivacyPolicyComponent,
    JobLinkedInComponent,
    DocumentUploadComponent,
    DocumentImportComponent,
    SubmitAlertDialogComponent,
    multiselectComponent,
    AutoCompleteComponent
  ],
  providers: [
    HTTP_OVERRIDE_PROVIDER,
    ScriptLoadService,
    JobNearMeComponent,
    StatusBar,
    SplashScreen,
    JobSearchService,
    CountryPhoneCodeDetails,
    JobService,
    TimelineService,
    AuthenticationService,
    ValidationService,
    ProfileService,
    GeoLocationService,
    ResumeService,
    UploadResumeService,
    ResumeService,
    SettingsService,
    JobAlertService,
    SitemapService,
    ToastControllerService,
    TranslationLoaderService,
    Toast508Service,
    BrandingService,
    DocumentService,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    { provide: RECAPTCHA_LANGUAGE, useValue: window.localStorage.getItem(Storage.CULTURE)}
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts